/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UniversalCandidateGroupSchema } from './universalCandidateGroupSchema';
import type { UniversalJobGroupSchema } from './universalJobGroupSchema';
import type { UniversalPresetGroupSchema } from './universalPresetGroupSchema';
import type { UniversalProjectGroupSchema } from './universalProjectGroupSchema';
import type { UniversalSavedSearchGroupSchema } from './universalSavedSearchGroupSchema';
import type { UniversalSequenceGroupSchema } from './universalSequenceGroupSchema';
import type { UniversalSnippetGroupSchema } from './universalSnippetGroupSchema';
import type { UniversalTaskGroupSchema } from './universalTaskGroupSchema';

export interface UniversalSearchResponseSchema {
  /** @maxLength 200 */
  query: string;
  projects: UniversalProjectGroupSchema;
  jobs: UniversalJobGroupSchema;
  candidates: UniversalCandidateGroupSchema;
  sequences: UniversalSequenceGroupSchema;
  searches: UniversalSavedSearchGroupSchema;
  tasks: UniversalTaskGroupSchema;
  snippets: UniversalSnippetGroupSchema;
  presets: UniversalPresetGroupSchema;
}
